import { message } from 'antd';
import { Dispatch } from 'react';
import { Action } from '../../actions/inbound';
import { ActionType } from '../../actions-types';
import inboundService from '../../../modules/Warehouse/Inbound/service/inbound';
import {
  bodyCommentWarehouse,
  bodyCompleteInbound,
  inboundList
} from '../../reducers/inboundReducer/inboundReducers';
import { formatDateTime } from '@root/utils/helpers/formatDate';

export const handleListInbound = (
  page: number,
  sort?: boolean,
  fromDt?: string,
  toDt?: string,
  searchBy?: string,
  filterInput?: string
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_INBOUND_LIST
    });
    try {
      const resp = await inboundService.getPagination(
        page,
        sort,
        fromDt,
        toDt,
        searchBy,
        filterInput
      );
      const payload: any = {
        count: resp.count,
        rowData: resp.data?.map((row: inboundList) => {
          return {
            ...row,
            key: row.id,
            updatedAt: formatDateTime(row?.updatedAt)
          };
        })
      };
      dispatch({
        type: ActionType.GET_INBOUND_LIST_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_INBOUND_LIST_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// Get Inbound Detail
export const getInboundDetailHandle = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.GET_INBOUND_DETAIL });
    try {
      const inboundDetail = await inboundService.getDetailInbound(id);
      dispatch({
        type: ActionType.GET_INBOUND_DETAIL_SUCCESS,
        payload: inboundDetail
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_INBOUND_DETAIL_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

//Approve Inbound
export const approveInboundHandle = (
  id: string,
  body: bodyCommentWarehouse
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.APPROVE_INBOUND });
    try {
      const approveInbound = await inboundService.postApproveInbound(id, body);
      dispatch({
        type: ActionType.APPROVE_INBOUND_SUCCESS,
        payload: approveInbound
      });

      const inboundDetail = await inboundService.getDetailInbound(id);
      dispatch({
        type: ActionType.GET_INBOUND_DETAIL_SUCCESS,
        payload: inboundDetail
      });

      message.success('Approve Successfully');
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.APPROVE_INBOUND_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// Post inbound Approve
export const postInboundCompleteHandle = (
  id: string,
  body: bodyCompleteInbound
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.POST_COMPLETE });
    try {
      const completeData = await inboundService.postCompleteInbound(id, body);
      dispatch({
        type: ActionType.POST_COMPLETE_SUCCESS,
        payload: completeData
      });
      const inboundDetail = await inboundService.getDetailInbound(id);
      dispatch({
        type: ActionType.GET_INBOUND_DETAIL_SUCCESS,
        payload: inboundDetail
      });
      message.success('Complete Successfully');
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.POST_COMPLETE_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};
